import { Fragment, useState } from "react";

import { Link, useLocation } from "react-router-dom";

import { useUserState, useUserDispatch } from "../../../Contexts/UserContext";
import TermConditionModal from "../../termsConPrivacyModals/TermConditionModal";
import PrivacyModal from "../../termsConPrivacyModals/PrivacyModal";
import { useStaticPageContent } from "../../../hooks/useStaticPageContent";
import { staticContentDefaults } from "../../../data/staticContentDefaults";
import { buildFooterContactItems, isExternalFooterHref } from "../../../utils/footerContactUtils";
import CmsRichText, { cmsPlainText } from "../../common/CmsRichText";

import LogoSvg from "../../../assets/images/logo.svg";
import ApproveImg from "../../../assets/images/Approve.png";
import MailImg from "../../../assets/images/mailmessage.png";
import InstaImg from "../../../assets/images/instagram.png";
import TelephoneImg from "../../../assets/images/telephone.png";
import TwitterImg from "../../../assets/images/twitter.png";

import "./FooterStyle.css";

const Footer = () => {
  const { user } = useUserState();
  const dispatch = useUserDispatch();
  const currentRoute = useLocation();
  const pageContent = useStaticPageContent("footer");
  const footerContent = {
    ...staticContentDefaults.footer,
    ...pageContent,
    tagline: {
      ...staticContentDefaults.footer.tagline,
      ...pageContent?.tagline,
    },
    contact: {
      ...staticContentDefaults.footer.contact,
      ...pageContent?.contact,
    },
  };
  const [termConModal, setTermConModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);

  const userRoles = Array.isArray(user?.role)
    ? user.role
    : user?.role
      ? [user.role]
      : [];
  const otherRoles = userRoles.filter((r) => r !== user?.currentRole);

  const handleScroll = () => {
    if (currentRoute?.pathname === "/") {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }
  };
  const showTagline = ["/", "/properties", "/contact-us", "/about-us", "/blog"].includes(
    currentRoute.pathname
  );
  const taglineLines = footerContent.tagline?.lines || [];
  const footerContactItems = buildFooterContactItems(footerContent.contact);
  const footerContactIcons = {
    phone: TelephoneImg,
    email: MailImg,
    instagram: InstaImg,
    twitter: TwitterImg,
  };

  return (
    <Fragment>
      <footer>
        <section className="foot_sec">
          <div className="container-fluid">
            <div className="foot_sec_inner">
              <div className="foot_cont">
                <div className="foot_logo">
                  <Link to="/" onClick={() => handleScroll()}>
                    <img src={LogoSvg} />
                  </Link>
                </div>
                {showTagline ? (
                  <ul style={{ textAlign: "left", padding: "20px 10px 0 10px" }}>
                    {taglineLines.map((line, index) => (
                      <li key={`tagline-${index}`} style={{ listStyle: "none" }}>
                        <p style={{ marginTop: 0 }}>
                          <CmsRichText as="span" value={line} />
                        </p>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
              <div className="foot_cont">
                <div className="foot_head">Druyp</div>
                <ul>
                  <li>
                    <Link to="/" onClick={() => handleScroll()}>
                      <img src={ApproveImg} /> Home
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/properties">
                      <img src={ApproveImg} /> Get a Choice
                    </Link>
                  </li> */}
                  {/* <li>
                    <a href="#">
                      <img src={ApproveImg} /> Download
                    </a>
                  </li> */}
                  <li>
                    <Link to="/contact-us">
                      <img src={ApproveImg} /> Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog">
                      <img src={ApproveImg} /> Blog
                    </Link>
                  </li>
                </ul>
              </div>
              {user &&
                userRoles.length <= 3 &&
                userRoles.length > 1 &&
                !userRoles.includes("furniture_company") &&
                !userRoles.includes("cleaning_company") &&
                !userRoles.includes("relo") && (
                  <div className="foot_cont">
                    <div className="foot_head">Host</div>
                    <ul>
                      {otherRoles.map((r, index) => (
                        <li key={index}>
                          <Link
                            to={
                              r === "tenant"
                                ? "/user_dash/tenant"
                                : r === "home_owner"
                                  ? "/user_dash/home_owner"
                                  : r === "property_manager"
                                    ? "/user_dash/property_manager"
                                    : ""
                            }
                            onClick={() => {
                              const updatedUserRole = {
                                ...user,
                                currentRole: r,
                              };
                              // Dispatch an action to update the user in the context
                              dispatch({
                                type: "UPDATE_USER",
                                payload: updatedUserRole,
                              });
                            }}
                          >
                            <img src={ApproveImg} />{" "}
                            {r === "tenant"
                              ? "Tenant"
                              : r === "home_owner"
                                ? "Home Owner"
                                : r === "property_manager"
                                  ? "Property Manager"
                                  : ""}
                          </Link>
                        </li>
                      ))}
                      {/* {user?.currentRole === "tenant" ? (
                        <Link
                          to="/user_dash/home_owner"
                          onClick={() => {
                            const updatedUserRole = {
                              ...user,
                              currentRole: "home_owner",
                            };
                            // Dispatch an action to update the user in the context
                            dispatch({
                              type: "UPDATE_USER",
                              payload: updatedUserRole,
                            });
                          }}
                        >
                          <img src={ApproveImg} /> House Owner
                        </Link>
                      ) : user?.currentRole === "home_owner" ? (
                        <Link
                          to="/user_dash/tenant"
                          onClick={() => {
                            const updatedUserRole = {
                              ...user,
                              currentRole: "tenant",
                            };
                            // Dispatch an action to update the user in the context
                            dispatch({
                              type: "UPDATE_USER",
                              payload: updatedUserRole,
                            });
                          }}
                        >
                          <img src={ApproveImg} /> Tenant
                        </Link>
                      ) : (
                        ""
                      )} */}

                      {/* <li>
                    <a href="#">
                      <img src={ApproveImg} /> Furniture Company
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={ApproveImg} /> Cleaning Company
                    </a>
                  </li> */}
                    </ul>
                  </div>
                )}

              <div className="foot_cont">
                <div className="foot_head">Other Links</div>
                <ul>
                  <li>
                    <Link to="/about-us">
                      <img src={ApproveImg} /> About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms-condition">
                      <img src={ApproveImg} /> Terms &amp; Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">
                      <img src={ApproveImg} /> Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="foot_cont">
                <div className="foot_head">Contact us</div>
                <ul>
                  {footerContactItems.map((item) => {
                    const label = cmsPlainText(item.value);
                    const href = item.href;

                    if (!href) {
                      return (
                        <li key={item.type}>
                          <span className="foot-contact-link">
                            <img src={footerContactIcons[item.iconKey]} alt="" />{" "}
                            {label}
                          </span>
                        </li>
                      );
                    }

                    const external = isExternalFooterHref(href);

                    return (
                      <li key={item.type}>
                        <a
                          href={href}
                          className="foot-contact-link"
                          target={external ? "_blank" : undefined}
                          rel={external ? "noopener noreferrer" : undefined}
                        >
                          <img src={footerContactIcons[item.iconKey]} alt="" />{" "}
                          {label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
          <hr className="m-0" />
          <div className="foot_copyright">
            <p>
              ©{new Date().getFullYear()}{" "}
              <CmsRichText as="span" value={footerContent.copyright} />
            </p>
          </div>
        </section>
      </footer>

      {/* <TermConditionModal
        termConModal={termConModal}
        setTermConModal={setTermConModal}
      />
      <PrivacyModal
        privacyModal={privacyModal}
        setPrivacyModal={setPrivacyModal}
      /> */}
    </Fragment>
  );
};

export default Footer;
